module.exports = __webpack_public_path__ + "static/majimasashi-b189cfc420cbecc4c5ba8c88ff02ef42.jpg";